import styled from "styled-components";
import { StyledButtonIcon } from "../UI/Button/Button-styled";

export const StyledTab = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  --calcite-tab-content-block-padding: 0;
  padding-top: 46px;
`;

export const StyledHeaderDate = styled.span`
  font-size: 10px;
  color: #999;
  font-weight: 500;
  display: flex;
  justify-content: center;
  text-wrap: nowrap;
`;

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 6px ${({ showBorder }) => (showBorder ? "8px" : "0px")} 6px;
  border-bottom: ${({ showBorder }) => (showBorder ? "1px solid #ededed" : "")};
  position: relative;

  @media screen and (max-width: 769px) {
    padding-top: 0;
  }
`;

export const StyledHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 14px;
  margin: auto;

  p {
    margin: 0;
    color: #393738;
    line-height: 1;
    font-weight: 500;
    font-size: 20px;
    text-wrap: nowrap;
  }
  span {
    text-wrap: nowrap;
  }

  @media screen and (max-width: 768px) {
    display: none;
    padding-top: 0;
  }
`;

export const StyledDashboardPortal = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 2;
  pointer-events: none;
`;

export const StyledTabHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 54px;
  gap: 4px;
  padding: 0px 16px 2px;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  max-width: 350px;
  margin-left: auto;

  opacity: ${({ expand }) => (expand ? 1 : 0)};
`;

export const StyledTabButton = styled(StyledButtonIcon)``;
